import React, { Component } from "react"
import ReactEcharts from "echarts-for-react"
import { Row, Col } from "reactstrap"

class VesselStayChart extends Component<any> {
    vesselStay = () => {
        let VesselStayArray: any[] = [
            {
                type: 'At Sea',
                1: 0,
                4: 0,
                6: 0,
                total: 0
            },
            {
                type: 'In Port',
                2: 0,
                3: 0,
                5: 0,
                4: 0,
                total: 0
            }
        ];

        this.props.pieChartData.map((data: any) => {
            if (data.vessel_position_id === 1) {
                VesselStayArray[1][data.reporting_operation_id] += data.time_duration;
                VesselStayArray[1].total += data.time_duration;
            } else {
                VesselStayArray[0][data.reporting_operation_id] = VesselStayArray[0][data.reporting_operation_id] + data.time_duration;
                VesselStayArray[0].total = VesselStayArray[0].total + data.time_duration;
            }
            return '';
        })

        return {
            toolbox: {
                show: false,
            },
            tooltip: {
                trigger: "item",
                formatter: (params: any) =>
                    `${params.seriesName} <br/>${params.data.name} : ${params.percent}% (${(params.data.value / 60).toFixed(2)} hr)`,
            },
            legend: {
                orient: "vertical",
                left: "left",
                data: VesselStayArray.map((data: any) => { return data.type.toString() }),
                // textStyle: {
                //   color: ["#858d98"],
                // },
            },
            color: ['#2ab57d', '#5156be'],
            series: [
                {
                    name: "Vessel stay",
                    type: "pie",
                    radius: "55%",
                    center: ["50%", "60%"],
                    data: VesselStayArray.map((data: any) => {
                        return (
                            {
                                value: data.total,
                                name: data.type
                            }
                        )
                    }),
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                        },
                    },
                },
            ],
        }
    }
    inPortOp = () => {
        let VesselStayArray: any = {
            type: 'In Port',
            operations: [
                { id: 2, time: 0, name: 'Port Stay' },
                { id: 3, time: 0, name: 'Anchor Stay' },
                { id: 4, time: 0, name: 'Maneuvering' },
                { id: 5, time: 0, name: 'Drifting' },
            ],
            total: 0
        };

        this.props.pieChartData.map((data: any) => {
            return VesselStayArray.operations
                .filter((item: any) => item.id === data.reporting_operation_id && data.vessel_position_id === 1).map((op: any) => {
                    op.time = op.time + data.time_duration;
                    op.total = op.total + data.time_duration;
                    return '';
                })
        })

        return {
            toolbox: {
                show: false,
            },
            tooltip: {
                trigger: "item",
                formatter: (params: any) =>
                    `${params.seriesName} <br/>${params.data.name} : ${params.percent}% (${(params.data.value / 60).toFixed(2)} hr)`,
            },
            legend: {
                orient: "vertical",
                left: "left",
                data: VesselStayArray.operations.map((data: any) => {
                    return data.name.toString();
                }),
                // textStyle: {
                //   color: ["#858d98"],
                // },
            },
            color: ['#2ab57d', '#008d3d', '#98fb98', '#10dbb2',],
            series: [
                {
                    name: "In Port operations",
                    type: "pie",
                    radius: "55%",
                    center: ["50%", "60%"],
                    data: VesselStayArray.operations.map((data: any) => {
                        return {
                            value: data.time,
                            name: data.name
                        }
                    }),
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                        },
                    },
                },
            ],
        }
    }
    atSeaOp = () => {

        let VesselStayArray: any = {
            type: 'At Sea',
            operations: [
                { id: 1, time: 0, name: 'Sea Passage' },
                { id: 4, time: 0, name: 'Maneuvering' },
                { id: 6, time: 0, name: 'Drifting' },
            ],
            total: 0
        };

        this.props.pieChartData.map((data: any) => {
            return VesselStayArray.operations
                .filter((item: any) => item.id === data.reporting_operation_id && data.vessel_position_id === 2).map((op: any) => {
                    op.time = op.time + data.time_duration;
                    op.total = op.total + data.time_duration;
                    return '';
                })
        })

        return {
            toolbox: {
                show: false,
            },
            tooltip: {
                trigger: "item",
                formatter: (params: any) => `${params.seriesName} <br/>${params.data.name} : ${params.percent}% (${(params.data.value / 60).toFixed(2)} hr)`,
            },
            legend: {
                orient: "vertical",
                left: "left",
                data: VesselStayArray.operations.map((data: any) => {
                    return data.name.toString();
                }),
                // textStyle: {
                //   color: ["#858d98"],
                // },
            },
            color: ['#017cf7', '#00b9f7', '#030b76'],
            series: [
                {
                    name: "At Sea operations",
                    type: "pie",
                    radius: "55%",
                    center: ["50%", "60%"],
                    data: VesselStayArray.operations.map((data: any) => {
                        return {
                            value: data.time,
                            name: data.name
                        }
                    }),
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                        },
                    },
                },
            ],
        }
    }
    render() {
        return (
            <React.Fragment>
                <Row>
                    <Col lg={4}>
                        <strong>Vessel stay</strong>
                        <ReactEcharts style={{ height: "350px" }} option={this.vesselStay()} />
                    </Col>
                    <Col lg={4}>
                        <strong>In Port operations</strong>
                        <ReactEcharts style={{ height: "350px" }} option={this.inPortOp()} />
                    </Col>
                    <Col lg={4}>
                        <strong>At Sea operations</strong>
                        <ReactEcharts style={{ height: "350px" }} option={this.atSeaOp()} />
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}
export default VesselStayChart;
